import dataPrismic from "@/hooks/dataPrismic";

export const errorDictionary = (
  key: string,
  errors: typeof dataPrismic.errors
): string => {
  return errors?.[key as keyof typeof errors] ?? errors.generic;
};
